export class User {
  id: string;
  firstName: string;
  lastName: string;
  email: string;
  password: string;
  userType: number;
  role_id: number;
  role?: {
    id: number;
    name: string;
  } | null;
  phone?: string;
  avatar?: string;
  createdAt?: string;
  updatedAt?: string;
  
  // Trainee profile data
  trainee?: {
    id: number;
    firstname: string;
    lastname: string;
    phone: string;
    email: string;
    user_id: number;
  } | null;
  
  // Training center profile data
  trainingCenter?: {
    id: number;
    name: string;
    logo: string;
    phone_number: string;
    about: string;
    address: string;
    website: string;
    social_media_links: string;
    field_ids: number[];
    user_id: number;
    wilaya_id: number | null;
  } | null;

  constructor(data: Partial<User> = {}) {
    this.id = data.id || '';
    this.firstName = data.firstName || '';
    this.lastName = data.lastName || '';
    this.email = data.email || '';
    this.password = data.password || '';
    this.userType = data.userType || 0;
    this.role_id = data.role_id || 3; // default to trainee
    this.role = data.role || null;
    this.phone = data.phone;
    this.createdAt = data.createdAt;
    this.updatedAt = data.updatedAt;
    this.trainee = data.trainee || null;
    this.trainingCenter = data.trainingCenter || null;
  }

  get fullName(): string {
    // Use trainee data if available (this is the primary source for trainee names)
    if (this.trainee && this.trainee.firstname && this.trainee.lastname) {
      return `${this.trainee.firstname} ${this.trainee.lastname}`;
    }
    // Use training center name if available
    if (this.trainingCenter && this.trainingCenter.name) {
      return this.trainingCenter.name;
    }
    // If we have firstName and lastName, use them
    if (this.firstName && this.lastName) {
      return `${this.firstName} ${this.lastName}`;
    }
    // If we only have firstName, use it
    if (this.firstName) {
      return this.firstName;
    }
    // If we only have lastName, use it
    if (this.lastName) {
      return this.lastName;
    }
    // Fall back to email if no name is available
    return this.email;
  }

  get initials(): string {
    // Use trainee data if available and has firstname/lastname
    if (this.trainee && this.trainee.firstname && this.trainee.lastname) {
      return `${this.trainee.firstname[0]}${this.trainee.lastname[0]}`.toUpperCase();
    }
    // Use training center name if available
    if (this.trainingCenter && this.trainingCenter.name) {
      return this.trainingCenter.name.substring(0, 2).toUpperCase();
    }
    // If we have firstName and lastName, use them
    if (this.firstName && this.lastName) {
      return `${this.firstName[0]}${this.lastName[0]}`.toUpperCase();
    }
    // If we only have firstName, use first two characters
    if (this.firstName) {
      return this.firstName.substring(0, 2).toUpperCase();
    }
    // If we only have lastName, use first two characters
    if (this.lastName) {
      return this.lastName.substring(0, 2).toUpperCase();
    }
    // Fall back to email initials
    return this.email.substring(0, 2).toUpperCase();
  }

  // Helper methods to get profile data
  get address(): string | undefined {
    return this.trainingCenter?.address;
  }

  get city(): string | undefined {
    // This would need to be implemented based on your city/wilaya mapping
    return undefined;
  }

  get wilaya(): string | undefined {
    // This would need to be implemented based on your wilaya mapping
    return undefined;
  }

  get phoneNumber(): string | undefined {
    return this.trainee?.phone || this.trainingCenter?.phone_number || this.phone;
  }
} 